const ROOT_X = 212;
const ROOT_Y = 120;

function shard(angleDeg: number, length: number, width: number, seed: number) {
  const rad = (angleDeg * Math.PI) / 180;
  const ux = -Math.cos(rad);
  const uy = Math.sin(rad);
  const nx = Math.sin(rad);
  const ny = Math.cos(rad);
  const n = (value: number) => value.toFixed(1);
  const steps = [0.14, 0.3, 0.44, 0.58, 0.7, 0.8, 0.9];
  const profile = (t: number) => Math.sin(Math.PI * Math.min(1, t * 1.15)) * width;
  const left: string[] = [];
  const right: string[] = [];
  steps.forEach((t, index) => {
    const bite = (index + seed) % 3 === 0 ? 0.35 : 1;
    const nick = (index + seed) % 2 === 0 ? 0.55 : 1;
    const x = ROOT_X + ux * length * t;
    const y = ROOT_Y + uy * length * t;
    left.push(`L ${n(x + nx * profile(t) * bite)} ${n(y + ny * profile(t) * bite)}`);
    right.unshift(`L ${n(x - nx * profile(t) * 0.7 * nick)} ${n(y - ny * profile(t) * 0.7 * nick)}`);
  });
  const tipX = ROOT_X + ux * length;
  const tipY = ROOT_Y + uy * length;
  return [`M ${ROOT_X} ${ROOT_Y}`, ...left, `L ${n(tipX)} ${n(tipY)}`, ...right, 'Z'].join(' ');
}

function vein(angleDeg: number, length: number) {
  const rad = (angleDeg * Math.PI) / 180;
  const x = ROOT_X - Math.cos(rad) * length * 0.86;
  const y = ROOT_Y + Math.sin(rad) * length * 0.86;
  return `M ${ROOT_X - 6} ${ROOT_Y + 2} L ${x.toFixed(1)} ${y.toFixed(1)}`;
}

const PRIMARY_SPEC: [number, number, number][] = [
  [-58, 118, 17],
  [-40, 164, 20],
  [-22, 196, 21],
  [-4, 206, 21],
  [14, 188, 20],
  [32, 154, 18],
  [50, 112, 15],
];

const PRIMARIES = PRIMARY_SPEC.map(([angle, length, width], index) => shard(angle, length, width, index));
const VEINS = PRIMARY_SPEC.map(([angle, length]) => vein(angle, length));

const SECONDARIES = [
  shard(-46, 98, 16, 1),
  shard(-26, 128, 17, 2),
  shard(-6, 138, 17, 0),
  shard(14, 124, 16, 1),
  shard(34, 94, 14, 2),
];

const COVERTS = [shard(-30, 62, 14, 0), shard(-8, 74, 14, 1), shard(14, 64, 13, 2), shard(34, 48, 11, 0)];

function Shards({ paths, opacity }: { paths: string[]; opacity: number }) {
  return paths.map((d) => <path key={d} d={d} opacity={opacity} />);
}

export function SenitaWing({ grad, define = false, className = 'fx__wing fx__wing--senita' }: { grad: string; define?: boolean; className?: string }) {
  return (
    <svg className={className} viewBox="0 0 240 260" aria-hidden="true">
      {define && (
        <defs>
          <linearGradient id={grad} x1="1" y1="0.3" x2="0" y2="0.7">
            <stop offset="0%" stopColor="#05010c" />
            <stop offset="38%" stopColor="#2a0b4d" />
            <stop offset="72%" stopColor="#5d1470" />
            <stop offset="92%" stopColor="#b3245f" />
            <stop offset="100%" stopColor="#ffcf7a" />
          </linearGradient>
          <linearGradient id={`${grad}-vein`} x1="1" y1="0" x2="0" y2="0">
            <stop offset="0%" stopColor="#c58bff" stopOpacity="0" />
            <stop offset="45%" stopColor="#c58bff" />
            <stop offset="100%" stopColor="#ff5f8f" />
          </linearGradient>
        </defs>
      )}
      <g className="fx__feather-row fx__feather-row--3" fill={`url(#${grad})`}>
        <Shards paths={PRIMARIES} opacity={0.96} />
        <g className="fx__wing-veins" stroke={`url(#${grad}-vein)`} strokeWidth="1.3" fill="none" strokeLinecap="round">
          {VEINS.map((d) => (
            <path key={d} d={d} />
          ))}
        </g>
      </g>
      <g className="fx__feather-row fx__feather-row--2" fill={`url(#${grad})`}>
        <Shards paths={SECONDARIES} opacity={0.88} />
      </g>
      <g className="fx__feather-row fx__feather-row--1" fill={`url(#${grad})`}>
        <Shards paths={COVERTS} opacity={0.8} />
      </g>
    </svg>
  );
}

export function SenitaWings({ idPrefix }: { idPrefix: string }) {
  const grad = `${idPrefix}-swing`;
  return (
    <>
      <span className="fx__wing-slot fx__wing-slot--left fx__wing-slot--senita">
        <SenitaWing grad={grad} define />
      </span>
      <span className="fx__wing-slot fx__wing-slot--right fx__wing-slot--senita">
        <SenitaWing grad={grad} />
      </span>
    </>
  );
}
